export default __webpack_public_path__ + "static/media/Fog.4c5e468c.png";